import React, { useState, useCallback } from "react";
import { Drawer, Collapse, Empty } from "antd";
import { ButtonItem } from "./Items";
import RutaPickingAlmacen from "./RutaPickingAlmacen";

//Ruta de picking de una venta/pedido, con soporte para VARIOS almacenes a la vez: cada almacén (proyecto)
//se muestra en su propio panel colapsable 
const RutaPicking = ({ visible, onClose, onConfirmar, empresaId, headersToken, almacenes, titulo }) => {
  const [recolectadoPorProyecto, setRecolectadoPorProyecto] = useState({});

  const actualizarRecolectado = useCallback((proyectoId, cantidades) => {
    setRecolectadoPorProyecto((prev) => ({ ...prev, [proyectoId]: cantidades }));
  }, []);

  const hayAlgoMarcado = Object.values(recolectadoPorProyecto).some(
    (cantidades) => Object.keys(cantidades || {}).length > 0
  );

  const confirmar = () => {
    onConfirmar(recolectadoPorProyecto);
    setRecolectadoPorProyecto({});
  };

  const almacenesLista = almacenes || [];

  return (
    <Drawer
      title={titulo || "Ruta de picking"}
      visible={visible}
      onClose={onClose}
      width={680}
      bodyStyle={{ paddingBottom: 80 }}
      footer={
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <ButtonItem type="primary" verde onClick={confirmar} disabled={!hayAlgoMarcado}>
            Confirmar y continuar
          </ButtonItem>
        </div>
      }
    >
      {almacenesLista.length === 0 ? (
        <Empty description="No hay insumos pendientes para generar una ruta." />
      ) : (
        <Collapse defaultActiveKey={almacenesLista.map((a) => a.proyectoId)} bordered={false}>
          {almacenesLista.map((almacen) => (
            <Collapse.Panel key={almacen.proyectoId} header={<strong>{almacen.proyectoNombre || "Almacén"}</strong>}>
              <RutaPickingAlmacen
                visible={visible}
                empresaId={empresaId}
                headersToken={headersToken}
                proyectoId={almacen.proyectoId}
                proyectoNombre={almacen.proyectoNombre}
                insumosRequeridos={almacen.insumos}
                titulo={`${titulo || "Ruta de picking"} — ${almacen.proyectoNombre || ""}`}
                onRecolectadoChange={(cantidades) => actualizarRecolectado(almacen.proyectoId, cantidades)}
              />
            </Collapse.Panel>
          ))}
        </Collapse>
      )}
    </Drawer>
  );
};

export default RutaPicking;
